<template>
    <div class="main_container">
        <el-tabs type="border-card">
            <el-tab-pane label="撤除申请详情">
                <div class="view_mian">
                    <div class="title_sty">申请人基本信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="showWran?'showIcon':'hideIcon'">申请人姓名：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                     <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">申请人电话：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">所在单位：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="showWran?'showIcon':'hideIcon'">个人身份证明：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <div class="title_sty">待撤文章信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">题目名称：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">作者：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <!-- <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">发表刊物/比对库：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row> -->
                     <!-- <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">发表日期：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row> -->
                     <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">单位允许撤除证明：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">检测报告单：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">待撤文章位置：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">申请提交时间：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <div class="title_sty">审核意见</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">审核状态：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">审核意见：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">审核时间：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-button type="primary"  class="reApply_btn" @click="reApply">重新提交申请</el-button>
                    <div class="title_sty">撤除结果</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">撤除结果：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">结果详情：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">审核时间：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">XXXXX</div></el-col>
                    </el-row>
                    <div class="btn_box">
                        <el-button type="primary"  class="backRecord_btn" @click="backRecord">返回申请记录列表</el-button>
                    </div>

                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    data(){
        return{
            //  imgUrl:require("../../../assets/images/warn_icon1.png"),
            imgUrl:"",
            showWran:true
        }
    },
    methods:{
        backRecord(){
            var _this = this;
            _this.$router.push("applyRecord");
        },
        reApply(){
            var _this = this;
            _this.$router.push("applyIndex");
        }
    },
    created(){
        console.log("this.$router.params",this.$router.params);
    }

}
</script>

<style  scoped>
.view_mian{
    padding:30px 50px
}
.info_item{
    line-height: 40px;
    font-size: 14px;
    color:#606266;
}
.info_title{
    text-align: right;
}
.btn_box{
    margin-left:42%;
}
.reApply_btn{
    padding: 5px 10px;
    margin-bottom: 15px;
    margin-left: 112px;
 }
 .backRecord_btn{
     padding:8px 10px;
 }
 .warn_icon{
     margin-right:5px;
     vertical-align: middle;
 }

</style>



// WEBPACK FOOTER //
// viewBase.vue?573cddec